export const API_BASE_URL = 'https://qr.galleryg.com/api';
//export const API_BASE_URL = 'https://art_gallery.test/api';
